import React from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from '../Components/Auth/Login';
import PublicRouters from './PublicRouter';
import PrivateRouters from './PrivateRouter';
import AuthenticateProvider from '../Context/AuthenticateProvider';
import Dashboard from '../Components/Dashboard';
import Products from '../Components/Products';
import Cart from '../Components/Cart';
import MyOrders from '../Components/MyOrders';

const index = () => {
  return (
    <React.Fragment>
      <AuthenticateProvider>
        <Router>
          <Routes>
            <Route element={<PublicRouters />}>
              <Route path="/login/:slug" element={<Login />} />
              <Route path='/*' element={<Navigate to="/login" />} />
            </Route>
            <Route element={<PrivateRouters />}>
              <Route path='/' element={< Products />} />
              <Route path='/dashboard' element={< Dashboard />} />
              <Route path='/cart' element={< Cart />} />
              <Route path='/orders' element={< MyOrders />} />
              <Route path='/profile' element={< MyOrders />} />
            </Route>
          </Routes>
        </Router>
      </AuthenticateProvider>
    </React.Fragment>
  )
}

export default index
